import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge, Button } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class DataTableEB01DataCourse extends Component {

    render() {
        
        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, UserCookie, Masterbase } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.status !== '2') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
                    
                    <Row>
                        <Col md={12}>
                            {DataTable?.rows?.length > 0 ? 
                                <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance table-responsive ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                    >
                                    <thead>
                                        <tr>
                                            <th className="th-td-align-center th-width-175p th-font-sm">รหัสหลักสูตร</th>
                                            <th className="th-width-175p th-font-sm">หลักสูตร</th>
                                            <th className="th-width-175p th-font-sm">สถาบัน/หน่วยงาน</th>
                                            <th className="th-width-175p th-font-sm">สถานประกอบการ</th>
                                            <th className="th-td-align-center th-width-150p th-font-sm">อุตสาหกรรม</th>
                                            <th className="th-td-align-center th-width-100p th-font-sm">EB-01</th>
                                            <th className="th-td-align-center th-width-125p th-font-sm">การดำเนินงาน</th>
                                            <th className="th-td-align-center th-width-150p th-font-sm">สถานะหลักสูตร</th>
                                            <th className="th-width-50p"></th>
                                            <th className="th-td-align-center th-width-50p">
                                                {deleteChecked > 0 && (
                                                    <Form.Check 
                                                        type="checkbox"
                                                        checked={Deletes.checkAll}
                                                        onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                        className="checkbox-font-sm"
                                                    />
                                                )}
                                            </th>
                                        </tr>                                        
                                    </thead>
                                    <tbody>
                                        {DataTable.rows.map((row, index) => {

                                            Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                            
                                            rowId++;

                                            let del = true;
                                            if (['0', '1'].includes(row.status)) { del = false; }

                                            return (
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="td-font-sm text-center" title={row.official_course_code}>
                                                                
                                                                <Badge bg="success" size="md" className="badge-size-sm">{row.official_course_code}</Badge>
                                                                
                                                            </td>
                                                            <td className="text-truncate td-font-sm" title={row.th_name}>{row.th_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.academy_name}>{row.academy_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.enterprise_name}>{row.enterprise_name}</td>
                                                            <td className="text-truncate td-font-sm" title={row.target_industries_name}>{row.target_industries_name}</td>
                                                            <td className="text-truncate td-font-sm th-td-align-center"> 
                                                                <CommonButton 
                                                                    task="open-content"
                                                                    rounded={true}
                                                                    disabled={false}
                                                                    inlineClass='btn-font-sm text-secondary'
                                                                    callback={() => Actions.handlePrintEBPopup('eb01-print',row.id)} 
                                                                />                                                                                                                                                                                        
                                                            </td> 
                                                            <td className="th-td-align-center">
                                                                <CommonDropdown
                                                                    element="DataTable"
                                                                    input={{id: 'operation', value: row.operation}}
                                                                    option={{source: 'options', section: 'status', item: 'eb01_course_operation_status'}}
                                                                    size="sm"
                                                                    callback={async (e, element) => { 
                                                                        if (['1'].includes(e.target.value)){
                                                                            await onSetEdit(e, {id: row.id}, true);
                                                                        }else{                                                                        
                                                                            onDropDownChange(e, element, {key: 'id', value: row.id});
                                                                        }
                                                                    }}
                                                                    disabled={['0', '1'].includes(row.status)}
                                                                />                                                                 
                                                            </td>
                                                            <td className={row.operation === '1' ? "text-truncate td-font-sm" : "th-td-align-center"}>
                                                                {row.operation === '1' ? (
                                                                    <>{row.operation_comment || '-'}</>
                                                                ) : (
                                                                    row.operation === '3' && (
                                                                    <CommonDropdown
                                                                        element="DataTable"
                                                                        input={{ id: 'status', value: row.status }}
                                                                        option={{
                                                                        source: 'options',
                                                                        section: 'status',
                                                                        item: 'eb01_course_approve_status'
                                                                        }}
                                                                        size="sm"
                                                                        callback={async (e, element) => {
                                                                        if (['0', '1'].includes(e.target.value)) {
                                                                            await onSetEdit(e, { id: row.id }, true);
                                                                        } else {
                                                                            await onDropDownChange(e, element, {
                                                                            key: 'id',
                                                                            value: row.id
                                                                            });
                                                                        }
                                                                        }}
                                                                        disabled={!['0','1'].includes(UserCookie?.types)}
                                                                    />
                                                                    )
                                                                )}
                                                            </td>
                                                            <td className="th-td-align-center">
                                                                {del && !(UserCookie?.types === '2' && UserCookie?.id === row.id) && (
                                                                    <CommonButton 
                                                                        task="edit" 
                                                                        rounded={false}
                                                                        disabled={false}
                                                                        inlineClass="btn-font-sm"
                                                                        callback={(e) => onSetEdit(e, {id: row.id})} 
                                                                    />
                                                                )}
                                                            </td>
                                                            <td className="th-td-align-center">
                                                                {del && !(UserCookie?.types === '2' && UserCookie?.id === row.id) && (
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        name="deletes"
                                                                        value={row.id}
                                                                        checked={Deletes.deletes.includes(row.id)}
                                                                        onChange={(e) => onCheckDelete(e)} 
                                                                        className="checkbox-font-sm"
                                                                    />
                                                                )}
                                                            </td>                                                            
                                                        </tr>
                                                    </React.Fragment>       
                                              )
                                        })}
                                        </tbody>                                                                                  
                                </Table>    
                            :
                                <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                            }

                            {!Action.Loading.dataTable && (
                                <CommonPagination 
                                    Pagination={DataTable.pagination} 

                                    handlePagination={(paging) => onPaginationChange(paging)}
                                />
                            )}                 
                        </Col>
                    </Row>

            </Container>
        );                
    }
}

export default DataTableEB01DataCourse;
